import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const listProducts = (params) => {
    return api.get(ENDPOINTS.PRODUCTS.LIST, { params });
};

export const getProductBySlug = (slug) => {
    return api.get(ENDPOINTS.PRODUCTS.BY_SLUG(slug));
};

export const listProductsByCategory = (slug, params) => {
    return api.get(ENDPOINTS.PRODUCTS.BY_CATEGORY(slug), { params });
};

export const listProductsByBrand = (slug, params) => {
    return api.get(ENDPOINTS.PRODUCTS.BY_BRAND(slug), { params });
};

// Compatible accessories for products currently in the cart / on a PDP.
export const getCartRecommendations = (productIds, limit = 12) => {
    return api.get(ENDPOINTS.RECOMMENDATIONS.CART, {
        params: { productIds: productIds.join(","), limit },
    });
};

// History-based (or trending fallback) accessory recommendations for cart/PDP.
export const getUserRecommendations = (limit = 12) => {
    return api.get(ENDPOINTS.RECOMMENDATIONS.USER, { params: { limit } });
};

// Homepage accessories — optional type filter + limit (All = sample; type = that category).
export const getHomeAccessories = (params = {}) => {
    const query =
        typeof params === "string"
            ? { accessoryType: params }
            : { ...params };
    return api.get(ENDPOINTS.ACCESSORIES.HOME, { params: query });
};
